import { InjectionToken } from '@angular/core';
/* eslint-disable @typescript-eslint/no-explicit-any */
export const DIALOG_DATA = new InjectionToken<any>('DIALOG_DATA');
